import Button from "../../../../../common/components/atom/Button/Button";
import { PermissionTooltip, useCapability } from "../../../../rbac";



export default function MinigridAddButtonPresenter() {
  const canEdit = useCapability('equipment.edit')

  return (
    <PermissionTooltip allowed={canEdit}>
      <Button onClick={() => {}} disabled={!canEdit} linkTo={'/main/minigrid/create'}  label='Créer un minigrid' iconRightType={'plus'}/>
    </PermissionTooltip>
  )
}
